import CustomInviteLogin from './pages';

export default CustomInviteLogin;
